module.exports = ELEMENT;


//////////////////
// WEBPACK FOOTER
// external "ELEMENT"
// module id = 199
// module chunks = 129